<!-- intentionally duplicated to reduce core dependencies -->

<template>
    <div class="save-status">
        <AutosaveStatus v-if="isSuccess || isSaving" :saving="isSaving" />

        <DsStatus
            v-else-if="isFailed"
            type="error"
            emphasis="medium"
            data-qa="save-failed"
        >
            {{ $t('funnel.saveFailed') }}
        </DsStatus>
    </div>
</template>

<script>
import AutosaveStatus from '@/components/shared/AutosaveStatus.vue';
import { SAVE_STATUS } from '../utils/editor.constants';

export default {
    components: {
        AutosaveStatus,
    },

    props: {
        status: {
            type: String,
            default: '',
        },
    },

    computed: {
        isSaving() {
            return this.status === SAVE_STATUS.SAVING;
        },

        isSuccess() {
            return this.status === SAVE_STATUS.SUCCESS;
        },

        isFailed() {
            return this.status === SAVE_STATUS.FAILED;
        },
    },
};
</script>

<style lang="scss" scoped>
.save-status {
    font-size: $font-size-sm;
}
</style>
